import waterModel from 'data/water_sidebar.json';
import waterLegend from 'data/water-legend.json';
import { getHandlerFor } from 'client/utils/angular';

export default function ($scope, $window, $rootScope, sidebarService) {
  $scope.waterSidebar = Object.assign({}, waterModel);
  $scope.waterLegend = waterLegend;
  $scope.isWaterInfo = false;

  const update = ({ watercourses, waterbody, floodplains, conservation, watershed }) => {
    //Check if there is river information
    if ('no_result' in watercourses) {
      $scope.waterSidebar.riverValue = "No";

      $scope.waterSidebar.riverInfo.error = watercourses.no_result;
    } else if ('error' in watercourses) {

      //Check if any errors in river information.
      //Set error message for user
      $scope.waterSidebar.riverValue = watercourses.error;

      $scope.waterSidebar.riverInfo.error = watercourses.error;
    } else {

      $scope.waterSidebar.riverValue = "Yes";

      //Set River info
      $scope.waterSidebar.riverInfo = watercourses;

      for (var i = 0; i < $scope.waterSidebar.riverInfo.length; i++) {
        if ($scope.waterSidebar.riverInfo[i].myp_label == null) {
          $scope.waterSidebar.riverInfo[i].myp_label = "Watercourse";
        }
      }

    }

    //Check if there is waterbody information
    if ('no_result' in waterbody) {
      $scope.waterSidebar.waterbodyValue = "No";

      $scope.waterSidebar.waterbodyInfo.error = waterbody.no_result;
    } else if ('error' in waterbody) {

      //Check if any errors in river information.
      //Set error message for user
      $scope.waterSidebar.waterbodyValue = waterbody.error;

      $scope.waterSidebar.waterbodyInfo.error = waterbody.error;

    } else {
      $scope.waterSidebar.waterbodyValue = "Yes";

      //Set Lake info
      $scope.waterSidebar.waterbodyInfo = waterbody;

      for (var i = 0; i < $scope.waterSidebar.waterbodyInfo.length; i++) {
        if ($scope.waterSidebar.waterbodyInfo[i].myp_label == null) {
          $scope.waterSidebar.waterbodyInfo[i].myp_label = "Waterbody";
        }
      }
    }

    //Check if there is floodplain information
    if ('no_result' in floodplains) {
      $scope.floodplainOn = false;
      $scope.waterSidebar.floodplainValue = "No";
      $scope.waterSidebar.floodplain[0].error = floodplains.no_result;
    } else if ('error' in floodplains) {
      $scope.floodplainOn = false;
      $scope.waterSidebar.floodplainValue = floodplains.error;
      $scope.waterSidebar.floodplain[0].error = floodplains.error;
    } else {
      //Set Floodplain info
      $scope.floodplainOn = true;
      $scope.waterSidebar.floodplainValue = "Yes";
      $scope.waterSidebar.floodplain[1] = floodplains;
    }

    //Check if there is conservation information
    if ('no_result' in conservation) {
      $scope.waterSidebar.conservationInfo.error = "No";
    } else if ('error' in conservation) {
      //Set conservation info with error message
      $scope.waterSidebar.conservationInfo[0].error = conservation.error;

    } else {
      //Set conservation info
      $scope.waterSidebar.conservationInfo = conservation;
    }

    //Check if there is watershed information
    if ('no_result' in watershed) {
      $scope.waterSidebar.watershedValue = "No";
      $scope.waterSidebar.watershedInfo.error = watershed.no_result;
    } else if ('error' in watershed) {

      //Set error message for user
      $scope.waterSidebar.watershedValue = watershed.error;
      $scope.waterSidebar.watershedInfo.error = watershed.error;

    } else {
      //Set watershed info
      $scope.waterSidebar.watershedValue = watershed[0].myp_label;
    }

  };

  if ($scope.legendTitle != "water")
    $rootScope.$broadcast('map/setlegend', [waterLegend, "water"]);//Set legend to water

  if (!$scope.isSearchBar) {
    //reset river on/off button if needed.
    $scope.waterSidebar.river[0].toggle = $scope.checkLayer($scope.waterSidebar.river[0].name);

    //reset floodplain on/off button if needed.
    $scope.waterSidebar.floodplain[0].toggle = $scope.checkLayer($scope.waterSidebar.floodplain[0].name);

    //reset contours on/off button if needed.
    $scope.waterSidebar.contours[0].toggle = $scope.checkLayer($scope.waterSidebar.contours[0].name);

    if (!$scope.onSidebar) {
      sidebarService.sidebarInfo({
        type: "water_sidebar",
        gid: $scope.sidebar.gid,
        myp_municipality: $scope.sidebar.myp_municipality
      }).success(update);
    }
  }

  //Tooltips for question marks in sidebar
  $scope.tooltip_river = {title: 'Click question mark for source', checked: true};
  $scope.tooltip_flood = {title: 'Click question mark for source', checked: true};
  $scope.tooltip_lake = {title: 'Click question mark for source', checked: true};
  $scope.tooltip_contours = {title: 'Click question mark for source', checked: true};
  $scope.tooltip_floodplain = {title: 'Click question mark for source', checked: true};

  //Turn off the dev app if it's turned on
  if ($rootScope.isDev) {
    $rootScope.$broadcast('map/setinfocontent', [$rootScope.address, 'address']);
    $rootScope.$broadcast('map/openaddresswindow');
    $rootScope.isDev = false;
    $rootScope.$broadcast('locationToggle');
  }

  $scope.openTab = function (url) {
    $window.open(url, '_blank');
  };

  $scope.riverTog = false;
  $scope.floodTog = false;
  $scope.lakeTog = false;
  $scope.conTog = false;

  const toggle = (status) => {
    $scope.waterSidebar.river[0].toggle = status;
    $scope.waterSidebar.floodplain[0].toggle = status;
    $scope.waterSidebar.contours[0].toggle = status;
  };

  const reset = () => {
    $scope.waterSidebar = Object.assign({}, waterModel);
  };

  $rootScope.$on('sidebar/water/update', getHandlerFor(update));
  $rootScope.$on('sidebar/water/toggle', getHandlerFor(toggle));
  $rootScope.$on('sidebar/water/reset', getHandlerFor(reset));

  return {
    update,
    toggle,
    reset
  };
};



// WEBPACK FOOTER //
// ./client/controllers/water_sidebar.js